
import {Component, Prop, Vue} from 'vue-property-decorator';
import TarafKisi from '@/plugins/uyap-plugin/takip_ac/parser/TarafKisi';
import TarafKurum from '@/plugins/uyap-plugin/takip_ac/parser/TarafKurum';
import {DosyaFormDataInterface} from '@/plugins/uyap-plugin/takip_ac/DosyaFormDataInterface';
import {IbanTercihiEnum} from '@/plugins/uyap-plugin/uyap/IbanTercihiEnum';
import AdresForm from '@/components/forms/AdresForm.vue';
import Adres from '@/plugins/uyap-plugin/takip_ac/parser/Adres';
import {VForm} from "@/types";
import IbanNumarasi from "@/components/inputs/IbanNumarasi.vue";
import HesapBilgisi from "@/plugins/uyap-plugin/takip_ac/parser/HesapBilgisi";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import VergiNumarasi from "@/components/inputs/VergiNumarasi.vue";
import DetsisNumarasi from "@/components/inputs/DetsisNumarasi.vue";
import UyapTakipAc from '@/plugins/uyap-plugin/takip_ac/UyapTakipAc';
import {TakipAcStatusEnum} from '@/plugins/uyap-plugin/takip_ac/parser/TakipAcStatusEnum';
import MtsTakipAc from "@/plugins/uyap-plugin/takip_ac/MtsTakipAc";

export interface TarafCardSatir {
  label: string;
  value: string;
  icon: string;
  editable?: boolean;
  fieldKey?: string;
  formatter?: string;
  isAdres?: boolean;
  isIbanSahibi?: boolean;
  isIbanNumarasi?: boolean;
}

@Component({
  components: {
    IbanNumarasi,
    AdresForm,
    TcKimlikNumarasi,
    VergiNumarasi,
    DetsisNumarasi,
  },
})
export default class TarafCard extends Vue {
  @Prop({type: Object, required: true})
  taraf!: TarafKisi | TarafKurum;

  @Prop({type: String, default: 'alacakli'})
  tur!: 'alacakli' | 'borclu';

  @Prop({type: Object})
  uyapTakipAc!: UyapTakipAc | MtsTakipAc;

  @Prop({default: false}) readonly isMts!: boolean;

  get formData(): DosyaFormDataInterface | null {
    const module = this.isMts ? 'mtsTakipHazirla' : 'takipHazirla';
    return this.$store.getters[`${module}/formData`] || null;
  }

  // Adres ekleme state
  showAddAddressDialog: boolean = false;
  newAddressFormData: any = {
    adres_tur_id: null,
    sehir_id: null,
    ilce_id: null,
    posta_kodu: null,
    adres: null
  };

  // Adres ekleme state
  ibanDialog = {
    show: false,
    formValue: "",
    close: () => {
      this.ibanDialog.show = false;
      this.ibanDialog.formValue = "";
    },
    success: () => {
      if ((this.$refs.ibanForm as VForm).validate()) {
        const hesapBilgisi = new HesapBilgisi();
        hesapBilgisi.ibanNumarasi = this.ibanDialog.formValue;

        this.taraf.addIBAN(hesapBilgisi);

        this.$forceUpdate();
        this.ibanDialog.show = false;
        this.ibanDialog.formValue = "";
        this.$toast.success('IBAN başarıyla eklendi');
      }
    }
  }

  // Vergi No / TCKN düzenleme state
  showEditDialog: boolean = false;
  editingField: 'vergiNo' | 'tcKimlikNo' | 'kurumAdi' | 'mersisNo' | 'detsisNo' | null = null;
  editFieldValue: string = '';
  isQueryRunning: boolean = false;

  get baslik(): string {
    return this.taraf.getIsim();
  }

  get editDialogTitle(): string {
    if (this.editingField === 'vergiNo') {
      return this.editFieldValue ? 'Vergi No Düzenle' : 'Vergi No Ekle';
    }
    if (this.editingField === 'tcKimlikNo') {
      return this.editFieldValue ? 'TC Kimlik No Düzenle' : 'TC Kimlik No Ekle';
    }
    if (this.editingField === 'kurumAdi') {
      return this.editFieldValue ? 'Kurum Adı Düzenle' : 'Kurum Adı Ekle';
    }
    if (this.editingField === 'mersisNo') {
      return this.editFieldValue ? 'Mersis No Düzenle' : 'Mersis No Ekle';
    }
    if (this.editingField === 'detsisNo') {
      return this.editFieldValue ? 'Detsis No Düzenle' : 'Detsis No Ekle';
    }
    return 'Düzenle';
  }

  get satirlar(): TarafCardSatir[] {
    return this.tarafSatirlariOlustur();
  }

  get iconRengi(): string {
    return this.tur === 'alacakli' ? '#E7000B' : '#5FB2F7';
  }

  get baslikIconRengi(): string {
    return this.tur === 'alacakli' ? '#E7000B' : '#5FB2F7';
  }

  get baslikStili(): Record<string, string> {
    const borderColor = this.tur === 'alacakli' ? '#FB2C36' : '#5FB2F7';
    return {
      borderBottom: `1.82px solid ${borderColor}`,
      paddingBottom: '8px',
      marginBottom: '12px'
    };
  }

  get baslikYaziStili(): Record<string, string> {
    const color = this.tur === 'alacakli' ? '#E7000B' : '#5FB2F7';
    return {
      color,
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.43'
    };
  }

  get icerikKartStili(): Record<string, string> {
    const borderColor = this.tur === 'alacakli'
        ? 'rgba(255, 201, 201, 0.5)'
        : 'rgba(95, 178, 247, 0.19)';
    return {
      border: `0.91px solid ${borderColor}`,
      backgroundColor: this.tur === 'alacakli'
          ? 'rgba(254, 242, 242, 0.5)'
          : 'rgba(95, 178, 247, 0.08)'
    };
  }

  get etiketStili(): Record<string, string> {
    const color = this.tur === 'alacakli' ? '#C10007' : '#4A9DD9';
    return {
      color,
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '1.33'
    };
  }

  tarafSatirlariOlustur(): TarafCardSatir[] {
    const alacakliMi = this.tur === 'alacakli';

    const temelAlanlar = [
      {
        label: 'Kurum Adı',
        key: 'temelBilgileri.kurumAdi',
        icon: 'mdi-domain',
        editable: true,
      },
      {
        label: 'Mersis No',
        key: 'temelBilgileri.mersisNo',
        icon: 'mdi-identifier',
        editable: true,
      },
      {
        label: 'Detsis No',
        key: 'temelBilgileri.detsisNo',
        icon: 'mdi-identifier',
        editable: true,
      },
      {
        label: 'Vergi No',
        key: 'temelBilgileri.vergiNo',
        icon: 'mdi-identifier',
        editable: true,
      },
      {
        label: 'TCKN',
        key: 'temelBilgileri.tcKimlikNo',
        icon: 'mdi-identifier',
        editable: true,
      }
    ];

    const alacakliAlanlari = [
      ...temelAlanlar,
      {
        label: 'IBAN Sahibi',
        key: 'ibanSahibi',
        icon: 'mdi-account',
        formatter: 'ibanSahibi' as const,
        fieldKey: 'ibanSahibi',
      },
    ];

    const borcluAlanlari = [
      ...temelAlanlar,
      {
        label: 'Borçlu vekili',
        key: 'borcluVekili',
        icon: 'mdi-account-tie',
        formatter: 'borcluVekili' as const,
      },
    ];

    const alanlar = alacakliMi ? alacakliAlanlari : borcluAlanlari;

    return alanlar
        .map(alan => ({
          label: alan.label,
          icon: alan.icon,
          value: this.tarafAlanDegeriAl(alan, this.taraf),
          editable: (alan as any).editable || false,
          fieldKey: alan.key,
          formatter: alan.formatter,
        }))
        .filter(satir => {
          // Boolean alanlar her zaman gösterilmeli
          if (satir.formatter === 'boolean') return true;

          // Kişi için Vergi No gösterilmemeli
          if (satir.fieldKey === 'temelBilgileri.vergiNo' && !this.taraf.kurumMu) {
            return false;
          }

          // Kurum için TCKN gösterilmemeli
          if (satir.fieldKey === 'temelBilgileri.tcKimlikNo' && this.taraf.kurumMu) {
            return false;
          }

          // Kişi için Kurum Adı, Mersis No ve Detsis No gösterilmemeli
          if ((satir.fieldKey === 'temelBilgileri.kurumAdi' || satir.fieldKey === 'temelBilgileri.mersisNo' || satir.fieldKey === 'temelBilgileri.detsisNo') && !this.taraf.kurumMu) {
            return false;
          }

          // Vergi No, TCKN, Kurum Adı ve Mersis No için düzenlenebilir ise "-" değerini de göster (kullanıcı ekleyebilsin)
          if (satir.editable) {
            return true;
          }

          // Diğer alanlar için "-" değerini filtrele
          return satir.value !== '-';
        });
  }

  tarafAlanDegeriAl(alan: {
    key: string;
    formatter?: string;
  }, taraf: TarafKisi | TarafKurum): string {
    if (alan.formatter === 'ibanSahibi') {
      if (this.formData?.ibanTercihi == IbanTercihiEnum.Avukat)
        return 'Avukat';
      else
        return 'Müvekkil';
    }

    if (alan.formatter === 'borcluVekili') {
      const vekiller = taraf.vekilListesi;
      if (vekiller.length > 0)
        return vekiller.map(vekil => `${vekil.ad} ${vekil.soyad}`).join(', ');
      else
        return 'Borçlu vekili bulunamadı';
    }

    const hamDeger = this.icIceDegerAl(taraf, alan.key);
    if (alan.formatter === 'boolean') return this.booleanEtiketi(hamDeger);
    if (alan.formatter === 'address') return this.adresFormatla(hamDeger);
    return this.metinNormallestir(
        typeof hamDeger === 'string' ? hamDeger : (hamDeger as any) ?? '-',
    );
  }

  icIceDegerAl(
      kaynak: Record<string, unknown> | TarafKisi | TarafKurum | undefined,
      yol: string | string[],
  ): unknown {
    if (!kaynak) return null;
    const parcalar = Array.isArray(yol) ? yol : yol.split('.');
    return parcalar.reduce<unknown>((acc, anahtar) => {
      if (acc === null || acc === undefined) return null;
      if (typeof acc !== 'object') return null;
      return (acc as Record<string, unknown>)[anahtar];
    }, kaynak as Record<string, unknown>);
  }

  adresFormatla(deger: unknown): string {
    if (!deger) return '-';
    if (Array.isArray(deger)) {
      return deger
          .map(val => this.metinNormallestir(String(val ?? '')))
          .filter(Boolean)
          .join(' / ') || '-';
    }
    return this.metinNormallestir(String(deger));
  }

  metinNormallestir(metin?: string | null): string {
    if (!metin) return '-';
    const normallestirilmis = metin.replace(/\s+/g, ' ').trim();
    return normallestirilmis.length ? normallestirilmis : '-';
  }

  booleanEtiketi(deger: unknown): string {
    if (deger === true || deger === 'E') return 'Evet';
    if (deger === false || deger === 'H') return 'Hayır';
    return 'Hayır';
  }

  adresGorunumuFormatla(adres: any): string {
    if (!adres) return '-';
    const parcalar: string[] = [];
    if (adres.adres) parcalar.push(adres.adres);
    if (adres.ilAdi) parcalar.push(adres.ilAdi);
    if (adres.ilceAdi) parcalar.push(adres.ilceAdi);
    if (adres.postaKodu) parcalar.push(adres.postaKodu);
    return parcalar.length > 0 ? parcalar.join(' / ') : '-';
  }

  adresSec(adresIndex: number) {
    if (!this.taraf || !this.taraf.adresList || adresIndex < 0 || adresIndex >= this.taraf.adresList.length) {
      return;
    }
    this.taraf.setAddressIndex(adresIndex);
    this.$forceUpdate();
  }

  ibanSec(ibanIndex: number) {
    if (!this.taraf || !this.taraf.ibanList || ibanIndex < 0 || ibanIndex >= this.taraf.ibanList.length) {
      return;
    }
    this.taraf.setIbanIndex(ibanIndex);
    this.$forceUpdate();
  }

  resetNewAddressForm() {
    this.newAddressFormData = {
      adres_tur_id: null,
      sehir_id: null,
      ilce_id: null,
      posta_kodu: null,
      adres: null
    };
  }

  closeAddAddressDialog() {
    this.showAddAddressDialog = false;
    this.resetNewAddressForm();
  }

  async handleAddAddress() {
    try {
      const adres = new Adres();

      // Adres form id yerine obje dönüyor
      adres.ilKodu=this.newAddressFormData.sehir_id?.kod;
      adres.ilceKodu=this.newAddressFormData.ilce_id?.kod;
      adres.adresTuru=this.newAddressFormData.adres_tur_id.uyap_kod;
      adres.adresTuruAciklama=this.newAddressFormData.adres_tur_id.isim;
      adres.adres=this.newAddressFormData.adres;
      adres.ilAdi=this.newAddressFormData.sehir_id?.isim;
      adres.ilceAdi=this.newAddressFormData.ilce_id?.isim;
      adres.postaKodu=this.newAddressFormData.postaKodu;
      adres.kaynak="xml";

      this.taraf.addAddress(adres);

      this.closeAddAddressDialog();
      this.$forceUpdate();
      
      this.$toast.success('Adres başarıyla eklendi');
    } catch (error) {
      console.error('Adres ekleme hatası:', error);
      this.$toast.error('Adres eklenirken hata oluştu');
    }
  }

  shouldShowEditButton(satir: TarafCardSatir): boolean {
    if (!satir.fieldKey) return false;

    // Vergi No için: sadece kurum ise göster
    if (satir.fieldKey === 'temelBilgileri.vergiNo') {
      return this.taraf.kurumMu === true;
    }

    // TCKN için: sadece kişi ise göster
    if (satir.fieldKey === 'temelBilgileri.tcKimlikNo') {
      return this.taraf.kurumMu === false;
    }

    // Kurum Adı, Mersis No ve Detsis No için: sadece kurum ise göster
    if (satir.fieldKey === 'temelBilgileri.kurumAdi' || satir.fieldKey === 'temelBilgileri.mersisNo' || satir.fieldKey === 'temelBilgileri.detsisNo') {
      return this.taraf.kurumMu === true;
    }

    return false;
  }

  handleFieldEdit(satir: TarafCardSatir) {
    if (!satir.fieldKey) return;

    // Hangi alan düzenleniyor?
    if (satir.fieldKey === 'temelBilgileri.vergiNo') {
      this.editingField = 'vergiNo';
      this.editFieldValue = this.taraf.temelBilgileri.vergiNo || '';
    } else if (satir.fieldKey === 'temelBilgileri.tcKimlikNo') {
      this.editingField = 'tcKimlikNo';
      this.editFieldValue = this.taraf.temelBilgileri.tcKimlikNo || '';
    } else if (satir.fieldKey === 'temelBilgileri.kurumAdi') {
      this.editingField = 'kurumAdi';
      this.editFieldValue = (this.taraf.temelBilgileri.kurumAdi || this.taraf.kurumAdi || '').replace(/^⚠️ HATA: .*$/, '').trim();
    } else if (satir.fieldKey === 'temelBilgileri.mersisNo') {
      this.editingField = 'mersisNo';
      this.editFieldValue = this.taraf.temelBilgileri.mersisNo || this.taraf.mersisNo || '';
    } else if (satir.fieldKey === 'temelBilgileri.detsisNo') {
      this.editingField = 'detsisNo';
      this.editFieldValue = this.taraf.temelBilgileri.detsisNo || this.taraf.detsisNo || '';
    } else {
      // Diğer düzenlenebilir alanlar için mevcut event'i kullan
      this.$emit('alan-duzenle', { field: satir.fieldKey, formatter: satir.formatter, rowIndex: 0 });
      return;
    }

    this.showEditDialog = true;
  }

  closeEditDialog() {
    this.showEditDialog = false;
    this.editingField = null;
    this.editFieldValue = '';
  }

  async saveFieldEdit() {
    if (!this.editingField) return;

    // Form validasyonu
    const form = this.$refs.editForm as VForm;
    if (!form.validate()) {
      return;
    }

    this.isQueryRunning = true;

    try {
      // Değeri güncelle
      if (this.editingField === 'vergiNo') {
        this.taraf.temelBilgileri.vergiNo = this.editFieldValue.trim();
        this.taraf.vergiNo = this.editFieldValue.trim();
      } else if (this.editingField === 'tcKimlikNo') {
        this.taraf.temelBilgileri.tcKimlikNo = this.editFieldValue.trim();
      } else if (this.editingField === 'kurumAdi' && this.taraf.kurumMu) {
        const value = this.editFieldValue.trim();
        this.taraf.temelBilgileri.kurumAdi = value;
        this.taraf.kurumAdi = value;
      } else if (this.editingField === 'mersisNo' && this.taraf.kurumMu) {
        const value = this.editFieldValue.trim();
        this.taraf.temelBilgileri.mersisNo = value;
        this.taraf.mersisNo = value;
      } else if (this.editingField === 'detsisNo' && this.taraf.kurumMu) {
        const value = this.editFieldValue.trim();
        this.taraf.temelBilgileri.detsisNo = value;
        this.taraf.detsisNo = value;
      }

      if (this.tur === 'alacakli') {
        await this.uyapTakipAc.runQuery();
      } else if (this.uyapTakipAc?.status === TakipAcStatusEnum.QUERY_FAIL) {
        await this.uyapTakipAc.runQuery();
      } else {
        await this.taraf.runQuery();
      }

      if (!this.isMts && this.uyapTakipAc?.parsedFile?.isIlamli()) {
        try {
          const ilamSorguResult = await this.uyapTakipAc.ilamSorgusuYap();
          if (ilamSorguResult.success) {
            this.$toast.success('Taraf ve ilam bilgileri güncellendi ve sorgulandı');
          } else {
            this.$toast.warning('Taraf bilgisi güncellendi ancak ilam sorgusu başarısız oldu');
          }
        } catch (ilamError: any) {
          console.error('İlam sorgulama hatası:', ilamError);
          this.$toast.warning('Taraf bilgisi güncellendi ancak ilam sorgusu yapılamadı');
        }
      } else {
        this.$toast.success('Taraf bilgisi güncellendi ve sorgulandı');
      }

      this.closeEditDialog();
      this.$forceUpdate();
    } catch (error: any) {
      console.error('Taraf sorgulama hatası:', error);
      const errorMessage = error?.message || 'Taraf sorgulanırken hata oluştu';
      this.$toast.error(errorMessage);
      // Hata olsa bile dialog'u kapat, kullanıcı tekrar deneyebilir
      this.closeEditDialog();
    } finally {
      this.isQueryRunning = false;
    }
  }
}
